import { Box, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useDialog } from "../Dialogs";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { TimescheduleAutocomplete } from "./TimescheduleAutocomplete";
import { Timeschedule } from "../../../../../store/api/TimescheduleApi";

function PickTimescheduleDialog({
  onAdd,
  salesareaId,
  disableItem,
  allowAlwaysActive = false,
}: {
  onAdd: (p: Timeschedule) => void;
  salesareaId: number;
  disableItem: (timeschedule: Timeschedule) => boolean;
  allowAlwaysActive?: boolean;
}) {
  const [timeschedule, setTimeschedule] = useState<Timeschedule>();
  return (
    <Box sx={{ width: "480px" }}>
      <DialogTitle>Pick a timeschedule</DialogTitle>
      <DialogContent>
        <TimescheduleAutocomplete
          onChange={(e, timeschedule) => {
            if (timeschedule) {
              setTimeschedule(timeschedule);
            }
          }}
          salesarea_id={salesareaId}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color={"success"}
          disabled={timeschedule == null}
          onClick={function () {
            if (timeschedule != null) {
              // TODO UX: Right now we show a warning, which is nice so you can't select invalid data.
              //          It would be preferable if
              //          pickers allowed disabling/custom rendering per item in the list of options
              //          so the user
              //            - can't pick the wrong one
              //            - knows "why" it's wrong
              //          Instead of showing you "made a mistake" after you've chosen a filtered item.
              if (disableItem(timeschedule)) {
                toast.warn("This timeschedule is already selected");
                return;
              }
              onAdd(timeschedule);
            }
          }}
          variant={"contained"}
        >
          Add
        </Button>
      </DialogActions>
    </Box>
  );
}

export default function usePickTimeschedule(
  salesareaId: number,
  {
    allowAlwaysActive = false,
  }: {
    allowAlwaysActive?: boolean;
  } = {}
) {
  const { createDialog, closeDialog } = useDialog();

  return ({ disableItem = () => false }: { disableItem?: (timeschedule: Timeschedule) => boolean } = {}) => {
    return new Promise<Timeschedule>((resolve) => {
      createDialog({
        name: "pick-timetable-dialog",
        children: (
          <PickTimescheduleDialog
            allowAlwaysActive={allowAlwaysActive}
            disableItem={disableItem}
            onAdd={function (timetable) {
              resolve(timetable);
              closeDialog("pick-timetable-dialog");
            }}
            salesareaId={salesareaId}
          />
        ),
      });
    });
  };
}
